import React from 'react'
import { NavLink } from 'react-router-dom'
import Prdx from './Prdx.css'


const About = () => {
    return (
        <div>
            <div className="container py-5 my-5">
                <div className="row">
                    <div className="col-md-6">
                        <h1 style={{flex:1,justifyContent: "center",alignItems: "center", textAlign:"center"}} className="text-primary fw-bold mb-4">About Us</h1>
                        <p>Soccer Cleats LB is a Store, Based on your sports Needs, mainly Football. You can find latest original football boots/cleats with the best prices
                        possible, and all in all best quality.
                        </p>
                        <hr className="my-4" />

                        <div className="openHours">
                        <h6 className="">Beirut, Lebanon</h6>
                        <h6 className="">Tyre, Lebanon</h6>
                        <p>+961 71406079</p>
                        <hr className="my-4" />
                        <h4> Store Hours </h4>
                        <p>Monday - Thursday: 11:00am - 7:00pm</p>
                        <p>Friday: 10:30am - 7:30pm</p>
                        <p>Sunday: 10:00am - 1:00pm</p>
                        <p> <i>We are closed on all major holidays.</i> </p>
                        </div>

                        {/*<NavLink to="/contact" className="btn btn-outline-primary px-3">Contact Us</NavLink>*/}
                    </div>
                    {<div className="col-md-6 d-flex justify-content-center">
                        <img src="/assets/images/bg/abt3.jpg" alt="About Us" height="500" width="" />
                    </div>}
                </div>
            </div>
            
        </div>
    )
}
export default About
